"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createApi = require("../createApi");

var ArticlesApi = function (_BaseApi) {
  (0, _inherits2["default"])(ArticlesApi, _BaseApi);

  function ArticlesApi(baseUrl) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      baseUrl: baseUrl
    };
    var olyEngineApi = arguments.length > 2 ? arguments[2] : undefined;
    var searchService = arguments.length > 3 ? arguments[3] : undefined;
    (0, _classCallCheck2["default"])(this, ArticlesApi);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ArticlesApi).call(this, baseUrl, options, olyEngineApi));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "searchService", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getArticlesTags", function (_ref) {
      var facet = _ref.facet,
          index = _ref.index,
          query = _ref.query;
      return _this.searchService.requestFacetValues({
        index: index,
        facet: facet,
        query: query
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getArticle", function (_ref2) {
      var articleId = _ref2.articleId,
          clientId = _ref2.clientId,
          _ref2$fromAdmin = _ref2.fromAdmin,
          fromAdmin = _ref2$fromAdmin === void 0 ? false : _ref2$fromAdmin,
          _ref2$withCollections = _ref2.withCollections,
          withCollections = _ref2$withCollections === void 0 ? false : _ref2$withCollections,
          language = _ref2.language;
      return _this.api.get("/articles/".concat(articleId), {
        params: {
          clientId: clientId,
          withCollections: withCollections,
          language: language
        },
        headers: {
          fromAdmin: fromAdmin
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getArticles", function (_ref3) {
      var clientId = _ref3.clientId,
          language = _ref3.language,
          _ref3$onlineFilter = _ref3.onlineFilter,
          onlineFilter = _ref3$onlineFilter === void 0 ? true : _ref3$onlineFilter,
          _ref3$skip = _ref3.skip,
          skip = _ref3$skip === void 0 ? 0 : _ref3$skip,
          limit = _ref3.limit,
          groups = _ref3.groups,
          tags = _ref3.tags,
          search = _ref3.search,
          _ref3$fromAdmin = _ref3.fromAdmin,
          fromAdmin = _ref3$fromAdmin === void 0 ? false : _ref3$fromAdmin,
          challengeId = _ref3.challengeId;
      return _this.api.get('/articles', {
        params: {
          clientId: clientId,
          language: language,
          onlineFilter: onlineFilter,
          skip: skip,
          groups: groups,
          tags: tags,
          search: search,
          limit: limit,
          challengeId: challengeId
        },
        headers: {
          fromAdmin: fromAdmin
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getArticlesFromCollection", function (_ref4) {
      var clientId = _ref4.clientId,
          collectionId = _ref4.collectionId,
          language = _ref4.language,
          search = _ref4.search,
          onlineFilter = _ref4.onlineFilter,
          limit = _ref4.limit,
          skip = _ref4.skip;
      return _this.api.get("/collections/".concat(collectionId, "/articles"), {
        params: {
          clientId: clientId,
          language: language,
          search: search,
          onlineFilter: onlineFilter,
          limit: limit,
          skip: skip
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createArticle", function (_ref5) {
      var data = _ref5.data,
          clientId = _ref5.clientId;
      return _this.api.post("/articles", {
        data: data,
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "editArticle", function (_ref6) {
      var articleId = _ref6.articleId,
          data = _ref6.data,
          clientId = _ref6.clientId;
      return _this.api.put("/articles/".concat(articleId), {
        data: data,
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteArticle", function (_ref7) {
      var articleId = _ref7.articleId,
          clientId = _ref7.clientId;
      return _this.api["delete"]("/articles/".concat(articleId), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createProgramChallengeArticles", function (_ref8) {
      var programArticles = _ref8.programArticles,
          clientId = _ref8.clientId;
      var payload = {
        data: programArticles
      };
      return _this.api.post("/articles/challenges/bulk", {
        data: payload,
        params: {
          clientId: clientId
        }
      });
    });
    _this.searchService = searchService;
    return _this;
  }

  return ArticlesApi;
}(_createApi.BaseApi);

var _default = ArticlesApi;
exports["default"] = _default;
//# sourceMappingURL=articles.js.map